(() => {
  'use strict';
  function initialize(scope) {
    scope.querySelectorAll('[data-price-range]').forEach(widget => {
      if (widget.dataset.ready) return;
      const min = widget.querySelector('[data-price-min]');
      const max = widget.querySelector('[data-price-max]');
      const limit = Number(max.max);
      const money = new Intl.NumberFormat(document.documentElement.lang || 'pt-BR', { style: 'currency', currency: widget.dataset.currency || 'BRL' });
      function update(changed) {
        if (Number(min.value) > Number(max.value)) {
          if (changed === min) min.value = max.value;
          else max.value = min.value;
        }
        const low = Number(min.value), high = Number(max.value);
        widget.style.setProperty('--price-start', (limit ? low / limit * 100 : 0) + '%');
        widget.style.setProperty('--price-end', (limit ? high / limit * 100 : 0) + '%');
        widget.querySelector('[data-price-min-label]').textContent = money.format(low);
        widget.querySelector('[data-price-max-label]').textContent = money.format(high);
        min.setAttribute('aria-valuetext', money.format(low));
        max.setAttribute('aria-valuetext', money.format(high));
        min.setAttribute('aria-valuemax', String(high));
        max.setAttribute('aria-valuemin', String(low));
        // Keep the lower thumb reachable when both handles meet at the upper end.
        min.style.zIndex = low === limit ? '3' : '1';
      }
      update();
      [min, max].forEach(input => {
        input.disabled = false;
        input.addEventListener('input', () => update(input));
      });
      widget.querySelectorAll('[data-price-fallback] input').forEach(input => { input.disabled = true; });
      widget.querySelector('[data-price-fallback]').hidden = true;
      widget.querySelector('[data-price-sliders]').hidden = false;
      widget.dataset.ready = 'true';
    });
  }
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();